import React from "react";
import { Fade } from "react-awesome-reveal";
import {
  FaRocket,
  FaExchangeAlt,
  FaGlobe,
  FaHeadset,
} from "react-icons/fa";
import { MdTrackChanges, MdTouchApp } from "react-icons/md";

const About = () => {
  const iconColor = "#ffcc29";

  return (
    <section id="about" className="about pb-50">
      <div className="about-wrapper sec-bg pos-rel pb-40 pt-40">
        <div className="container">

          {/* Section Title */}
          <div className="sec-title--two text-center">
            <Fade direction="down" triggerOnce duration={1500}>
              <h2 className="title">Why Choose Us</h2>
            </Fade>
          </div>

          {/* Content */}
          <div className="row justify-content-center mt-50">
            <div className="col-lg-12">
              <div className="row g-4 justify-content-center">

                {/* 1 */}
                <div className="col-lg-4 col-md-6">
                  <div className="my-xb-item--holder text-center p-4 h-100">
                    <FaRocket size={46} color={iconColor} />
                    <h3 className="xb-item--title pt-15">
                      Fast & Efficient Transfers
                    </h3>
                    <p className="xb-item--content mb-0">
                      Send money quickly with a streamlined process built to save you time.
                    </p>
                  </div>
                </div>

                {/* 2 */}
                <div className="col-lg-4 col-md-6">
                  <div className="my-xb-item--holder text-center p-4 h-100">
                    <FaExchangeAlt size={46} color={iconColor} />
                    <h3 className="xb-item--title pt-15">
                      Best Exchange Rates
                    </h3>
                    <p className="xb-item--content mb-0">
                      Get competitive, market-driven rates with full transparency and no surprises.
                    </p>
                  </div>
                </div>

                {/* 3 */}
                <div className="col-lg-4 col-md-6">
                  <div className="my-xb-item--holder text-center p-4 h-100">
                    <MdTouchApp size={46} color={iconColor} />
                    <h3 className="xb-item--title pt-15">
                      Simple & User-Friendly Experience
                    </h3>
                    <p className="xb-item--content mb-0">
                      An easy-to-use platform designed for smooth navigation on both web and mobile.
                    </p>
                  </div>
                </div>

                {/* 4 */}
                <div className="col-lg-4 col-md-6">
                  <div className="my-xb-item--holder text-center p-4 h-100">
                    <MdTrackChanges size={46} color={iconColor} />
                    <h3 className="xb-item--title pt-15">
                      Real-Time Transfer Tracking
                    </h3>
                    <p className="xb-item--content mb-0">
                      Track your transfer at every stage and know exactly when it reaches its destination.
                    </p>
                  </div>
                </div>

                {/* 5 */}
                <div className="col-lg-4 col-md-6">
                  <div className="my-xb-item--holder text-center p-4 h-100">
                    <FaGlobe size={46} color={iconColor} />
                    <h3 className="xb-item--title pt-15">
                      Wide Global Reach
                    </h3>
                    <p className="xb-item--content mb-0">
                      Send money to multiple countries through a reliable international network.
                    </p>
                  </div>
                </div>

                {/* 6 */}
                <div className="col-lg-4 col-md-6">
                  <div className="my-xb-item--holder text-center p-4 h-100">
                    <FaHeadset size={46} color={iconColor} />
                    <h3 className="xb-item--title pt-15">
                      Customer Support That Cares
                    </h3>
                    <p className="xb-item--content mb-0">
                      Our dedicated support team is always available to assist you whenever you need help.
                    </p>
                  </div>
                </div>

              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default About;
